import React from 'react';
import {AsyncComponent} from "../../../core/components/router/async-component";
import {ErrorBoundaryWrapper} from "../../../core/components/error-boundary/error-boundary-wrapper";

const BetBoostWidgetAsyncComponent = AsyncComponent(async () => import('./bet-boost-widget' /* webpackChunkName: "bet-boost-widget" */ ));

export const BetBoostWidgetAsync = (props) => {
  return <ErrorBoundaryWrapper>
    <React.Suspense fallback={<div/>}>
      <BetBoostWidgetAsyncComponent {...props}/>
    </React.Suspense>
  </ErrorBoundaryWrapper>
};
